import React from "react";
import CurrencyInput from "react-currency-masked-input";

export default function MoneyInput({ name, onBlur, onChange, value }) {
  return (
    <CurrencyInput
      name={name}
      onBlur={onBlur}
      onChange={(e, d) => onChange({ target: { name: name, value: d } })}
      value={value}
    />
  );
}

MoneyInput.defaultProps = {
  name: "",
  value: "",
};
